(function () {
  // Update the cart bubble DOM with the new count
  function updateBubble(itemCount) {
    const bubble   = document.querySelector('.cart-bubble');
    const countEl  = document.querySelector('[data-testid="cart-bubble"]');
    const srText   = document.querySelector('#cart-bubble-text .visually-hidden');

    if (!bubble || !countEl) return;

    if (itemCount > 0) {
      bubble.classList.remove('visually-hidden');
      countEl.classList.remove('hidden');
      countEl.textContent = itemCount;

      // Keep screen-reader text in sync
      if (srText) {
        const prefix = srText.textContent.split(':')[0].trim();
        srText.textContent = `${prefix}: ${itemCount}`;
      }

      // Dwell's circular ratio styling — only applies under 100
      if (itemCount <= 99) {
        bubble.setAttribute('data-maintain-ratio', '');
      } else {
        bubble.removeAttribute('data-maintain-ratio');
      }
    } else {
      bubble.classList.add('visually-hidden');
      countEl.classList.add('hidden');
    }
  }

  // Intercept all fetch() calls to Shopify cart endpoints
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) ?? '';

    return _fetch.apply(this, args).then((response) => {
      if (/\/cart\/(add|change|update)\.js/.test(url)) {
        response.clone().json().then((data) => {
          // /cart/change.js and /cart/update.js return the full cart
          // /cart/add.js returns only the line item — so we fetch fresh
          if (typeof data.item_count === 'number') {
            updateBubble(data.item_count);
          } else {
            fetch('/cart.js').then(r => r.json()).then(cart => updateBubble(cart.item_count));
          }
        });
      }
      return response;
    });
  };

  // Fallback: intercept XMLHttpRequest too (some older theme components use XHR)
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._cartUrl = url;
    return _open.call(this, method, url, ...rest);
  };

  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    if (/\/cart\/(add|change|update)\.js/.test(this._cartUrl)) {
      this.addEventListener('load', () => {
        try {
          const data = JSON.parse(this.responseText);
          if (typeof data.item_count === 'number') {
            updateBubble(data.item_count);
          } else {
            fetch('/cart.js').then(r => r.json()).then(cart => updateBubble(cart.item_count));
          }
        } catch (e) {}
      });
    }
    return _send.apply(this, args);
  };
})();